import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-baseline',
  templateUrl: './baseline.component.html',
  styleUrls: ['./baseline.component.scss']
})
export class BaselineComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
